import React from "react";
import { Link } from "react-router-dom";
import { fade, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import SettingsIcon from "@material-ui/icons/Settings";
import SearchIcon from "@material-ui/icons/Search";
import AccountCircle from "@material-ui/icons/AccountCircle";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from "../../auth/login-button";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";

export default function PrimarySearchAppBar() {
  const { isAuthenticated, logout } = useAuth0();

  const classes = useStyles(isAuthenticated);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  // const handleProfileMenuOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   handleMobileMenuClose();
  // };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  // const menuId = "primary-search-account-menu";
  // const renderMenu = (
  //   <Menu
  //     anchorEl={anchorEl}
  //     anchorOrigin={{ vertical: "top", horizontal: "right" }}
  //     id={menuId}
  //     keepMounted
  //     transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     open={isMenuOpen}
  //     onClose={handleMenuClose}
  //   >
  //     <MenuItem onClick={handleMenuClose}>My Account</MenuItem>
  //     <MenuItem onClick={handleMenuClose}>
  //       <LogoutButton />
  //     </MenuItem>
  //   </Menu>
  // );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <Link
        to="/superAdmin/manageAccount/allNews"
        className={classes.mobileLink}
      >
        <IconButton aria-label="show 11 new allNews" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <FormatListBulletedIcon />
          </Badge>
        </IconButton>
        <p style={{ fontSize: "1rem", margin: 0 }}>All News</p>
      </Link>
      <Link
        to="/superAdmin/manageAccount/allAccount"
        className={classes.mobileLink}
      >
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <SupervisorAccountIcon />
          </Badge>
        </IconButton>
        <p style={{ fontSize: "1rem", margin: 0 }}>All Accounts</p>
      </Link>
      <Link
        to="/superAdmin/manageAccount/reportChart"
        className={classes.mobileLink}
      >
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <AssessmentIcon />
          </Badge>
        </IconButton>
        <p style={{ fontSize: "1rem", margin: 0 }}>Analyze Data</p>
      </Link>

      <Link
        to="/superAdmin/manageAccount/profile"
        className={classes.mobileLink}
        // onClick={handleProfileMenuOpen}
      >
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p style={{ fontSize: "1rem", margin: 0 }}>Profile</p>
      </Link>
      <Link
        to="/superAdmin/manageAccount"
        className={classes.mobileLink}
        onClick={() =>
          logout({
            returnTo: window.location.origin,
          })
        }
      >
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <LockOpenIcon />
        </IconButton>
        <p style={{ fontSize: "1rem", margin: 0 }}>LogOut</p>
      </Link>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="static">
        <Toolbar>
          <Typography className={classes.title} variant="h6" noWrap>
            Super_Admin
            <br />
            <p style={{ fontSize: ".9rem" }}>News In Seconds</p>
          </Typography>
          {!isAuthenticated ? (
            <div
              className={classes.sectionDesktop}
              style={{ backgroundColor: "grey" }}
            >
              <LoginButton />
            </div>
          ) : (
            <>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder="Search…"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  className={classes.searchInput}
                  inputProps={{ "aria-label": "search" }}
                />
              </div>

              <div className={classes.sectionDesktop}>
                <Link
                  to="/superAdmin/manageAccount/allNews"
                  className={classes.desktopLink}
                >
                  <IconButton
                    aria-label="show 17 new notifications"
                    color="inherit"
                  >
                    <Badge badgeContent={0} color="secondary">
                      <FormatListBulletedIcon />
                    </Badge>
                  </IconButton>
                  <p style={{ fontSize: "1rem" }}>All News</p>
                </Link>
                <Link
                  to="/superAdmin/manageAccount/allAccount"
                  className={classes.desktopLink}
                >
                  <IconButton aria-label="show 4 new accounts" color="inherit">
                    <Badge badgeContent={0} color="secondary">
                      <SupervisorAccountIcon />
                    </Badge>
                  </IconButton>
                  <p style={{ fontSize: "1rem", margin: 0 }}>All Accounts</p>
                </Link>
                <Link
                  to="/superAdmin/manageAccount/reportChart"
                  className={classes.desktopLink}
                >
                  <IconButton aria-label="show 4 new mails" color="inherit">
                    <Badge badgeContent={0} color="secondary">
                      <AssessmentIcon />
                    </Badge>
                  </IconButton>
                  <p style={{ fontSize: "1rem", margin: 0 }}>Analyze Data</p>
                </Link>

                <Link
                  className={classes.desktopLink}
                  // onClick={handleProfileMenuOpen}
                  to="/superAdmin/manageAccount/profile"
                >
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    // aria-controls={menuId}
                    aria-haspopup="true"
                    color="inherit"
                  >
                    <AccountCircle />
                  </IconButton>
                  <p style={{ fontSize: "1rem" }}>Profile</p>
                </Link>
                <Link
                  to="/superAdmin/manageAccount"
                  className={classes.desktopLink}
                  onClick={() =>
                    logout({
                      returnTo: window.location.origin,
                    })
                  }
                >
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    // aria-controls={menuId}
                    aria-haspopup="true"
                    color="inherit"
                  >
                    <LockOpenIcon />
                  </IconButton>
                  <p style={{ margin: "0 0 0 .5rem", fontSize: "1rem" }}>
                    LogOut
                  </p>
                </Link>
              </div>
            </>
          )}
          <div className={classes.sectionMobile}>
            {isAuthenticated ? (
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <SettingsIcon />
              </IconButton>
            ) : (
              <LoginButton />
            )}
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {/* {renderMenu} */}
    </div>
  );
}

const useStyles = makeStyles((theme, props) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flex: 1,
    alignSelf: "center",
    margin: ".5rem 0.2rem 0 .2rem",
    textAlign: "left",
    [theme.breakpoints.up("sm")]: {
      textAlign: (props) => (props.isAuthenticated ? "left" : "center"),
      flex: (props) => (props.isAuthenticated ? 0.4 : 1),
      display: "block",
      width: "inherit",
    },
  },

  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    // width: "100%",
    flex: 0.1,
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      flex: 0.7,
      marginRight: theme.spacing(3),
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      cursor: "pointer",
      justifySelf: "right",
    },
  },
  searchInput: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  desktopLink: {
    textAlign: "center",
    lineHeight: 0,
    margin: "0 .8rem",
    textDecoration: "none",
    color: "inherit",
    "&:hover": { transform: "scale(1.08)", color: "inherit" },
  },
  mobileLink: {
    display: "flex",
    textDecoration: "none",
    alignItems: "center",
    // justifyContent: "center",
    width: "100%",
    padding: "0 .5rem",
    color: "inherit",
    "&:hover": { transform: "scale(1.08)", color: "inherit" },
  },
}));
